import React, { useRef, useEffect, useState } from 'react';
import './Banner.css';

const Banner = () => {
  const videoRef = useRef(null);
  const [videoDuration, setVideoDuration] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) {
      return;
    }

    // Video süresini al
    const handleLoadedMetadata = () => {
      const duration = video.duration;
      setVideoDuration(duration);
    };

    // Video yüklendiğinde ve oynatılabilir olduğunda oynat
    const handleCanPlay = () => {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            setIsAnimating(true);
          })
          .catch(() => {
            // Video oynatma hatası - sessizce yoksay
          });
      }
    };

    // Video bittiğinde başa al ve tekrar oynat
    const handleEnded = () => {
      setIsAnimating(false);
      // Animasyonu sıfırlamak için kısa bir gecikme
      setTimeout(() => {
        setIsAnimating(true);
      }, 50);
    };

    // Video hata durumu
    const handleError = () => {
      // Video hata durumu - sessizce yoksay
    };

    // Video yüklendiğinde
    const handleLoadedData = () => {
      if (video.readyState >= 2) {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              setIsAnimating(true);
            })
            .catch(() => {
              // Video oynatma hatası - sessizce yoksay
            });
        }
      }
    };

    // Video zamanlayıcısı - animasyonu kontrol et
    let lastProgress = -1;
    const handleTimeUpdate = () => {
      if (videoDuration > 0) {
        const currentTime = video.currentTime;
        const progress = (currentTime / videoDuration) * 100;
        
        // Video sonuna yaklaştığında animasyonu sıfırla (video loop olduğu için)
        // Video bitmeden 2 saniye önce (yaklaşık %95-98 arası)
        const secondsBeforeEnd = 2;
        const fadeOutProgress = ((videoDuration - secondsBeforeEnd) / videoDuration) * 100;
        
        if (progress >= fadeOutProgress && lastProgress < fadeOutProgress) {
          setIsAnimating(false);
        }
        // Video başında animasyonu tekrar başlat (loop için)
        if (progress <= 1 && lastProgress > 98) {
          setTimeout(() => {
            setIsAnimating(true);
          }, 50);
        }
        lastProgress = progress;
      }
    };

    video.addEventListener('loadedmetadata', handleLoadedMetadata);
    video.addEventListener('canplay', handleCanPlay);
    video.addEventListener('ended', handleEnded);
    video.addEventListener('error', handleError);
    video.addEventListener('loadeddata', handleLoadedData);
    video.addEventListener('timeupdate', handleTimeUpdate);
    
    // Video yüklemesini başlat
    video.load();
    
    // İlk oynatma denemesi
    setTimeout(() => {
      if (video.readyState >= 2) {
        video.play().catch(() => {
          // Video oynatma hatası - sessizce yoksay
        });
      }
    }, 100);
    
    return () => {
      video.removeEventListener('loadedmetadata', handleLoadedMetadata);
      video.removeEventListener('canplay', handleCanPlay);
      video.removeEventListener('ended', handleEnded);
      video.removeEventListener('error', handleError);
      video.removeEventListener('loadeddata', handleLoadedData);
      video.removeEventListener('timeupdate', handleTimeUpdate);
    };
  }, [videoDuration]);

  // Video süresine göre animasyon zamanlaması hesapla
  const getAnimationTiming = () => {
    if (videoDuration === 0) return {};
    
    // Animasyon süreleri (video süresinin yüzdesi olarak)
    // Yazılar daha önce gelsin
    const fadeInDelay1 = 0.05; // %5 - çok erken
    const fadeInDelay2 = 0.1; // %10 - erken
    const fadeInDelay3 = 0.15; // %15 - erken
    
    // Video bitmeden 2 saniye önce kaybolsun
    const secondsBeforeEnd = 2;
    const fadeOutStartTime = videoDuration - secondsBeforeEnd;
    
    return {
      '--video-duration': `${videoDuration}s`,
      '--fade-in-delay-1': `${videoDuration * fadeInDelay1}s`,
      '--fade-in-delay-2': `${videoDuration * fadeInDelay2}s`,
      '--fade-in-delay-3': `${videoDuration * fadeInDelay3}s`,
      '--fade-out-start-1': `${fadeOutStartTime}s`,
      '--fade-out-start-2': `${fadeOutStartTime + 0.1}s`,
      '--fade-out-start-3': `${fadeOutStartTime + 0.2}s`,
      '--fade-out-duration': `0.8s`,
    };
  };

  return (
    <section className="main-banner">
      <video 
        ref={videoRef}
        className="banner-video"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      >
        <source src="/assets/banners/banner.mp4" type="video/mp4" />
        <source src="/assets/banners/banner_1.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="banner-overlay">
        <div className="banner-content">
          <div 
            className={`banner-text ${isAnimating ? 'animating' : ''}`}
            style={getAnimationTiming()}
          >
            <p className="banner-subtitle banner-text-item item-1">NQC AGENCY</p>
            <h1 className="banner-title banner-text-item item-2">YOUR PARTNER FOR GLOBAL CERTIFICATION</h1>
            <h1 className="banner-title-gold banner-text-item item-3">STANDARDS</h1>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;

